import gql from 'graphql-tag'

export const queryContractFieldsList = () => {
	return {
		query: gql`
			{
				contract_fields: pdf_fields {
					id
					field_name
					db_table_name
					db_field_name
					field_variable
					active
				}
			}
		`,
		update: data =>
			data.contract_fields.map(item => ({
				id: item.id,
				field_name: item.field_name,
				db_table_name: item.db_table_name,
				db_field_name: item.db_field_name,
				field_variable: item.field_variable,
				edit: true,
				active: item.active
			}))
	}
}
